import React, { useEffect, useState } from 'react';
import ModuleCard from '../../dashboard/cards/ModuleCard';
import { dashboardService } from '../../../services/dashboardService';
import { bunkersMoneyTiles } from '../../dashboard/cards/bunkersMoneyTiles';

/**
 * The six module cards from the original landing page, as a widget.
 * Access flags come from the server (same rules as the old page); the
 * counts come from the existing metrics endpoint, fetched here so a slow
 * source only delays this card.
 */
const ModulesWidget = ({ data }) => {
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    let cancelled = false;
    dashboardService.getMetrics()
      .then((m) => { if (!cancelled) setMetrics(m); })
      .catch((err) => { console.error('My Desk: module metrics failed', err); if (!cancelled) setMetrics({}); });
    return () => { cancelled = true; };
  }, []);

  const m = metrics || {};
  const v = (items) => (metrics ? items : items.map((i) => ({ ...i, value: '—' })));
  const access = data.access || {};

  return (
    <div className="mydesk-modules-grid">
      <ModuleCard title="Trade Ops Cargo" backgroundClass="trade-operations-bg" moduleType="trade-operations-solids"
        route="/dashboard/trades/solids" locked={!access.trade_ops} delay={0}
        metrics={v([
          { value: m.deals_solids || 0, label: 'Active Deals' },
          { value: m.trade_recaps_solids || 0, label: 'Trade Recaps' },
          { value: m.deliveries_solids || 0, label: 'Deliveries' },
        ])} />
      <ModuleCard title="Trade Ops Bunkers" backgroundClass="trade-operations-fuels-bg" moduleType="trade-operations-fuels"
        route="/dashboard/trades/fuels" locked={!access.bunkers} delay={100}
        metrics={v([
          { value: m.trade_recaps_fuels || 0, label: 'Trade Recaps' },
          { value: m.deliveries_fuels || 0, label: 'Deliveries' },
          { value: m.fuel_enquiries_open_fuels || 0, label: 'Open Enquiries' },
          { value: m.fuel_enquiries_credit_pending || 0, label: 'Credit Pending' },
          { value: m.fuel_enquiries_awaiting_pricing || 0, label: 'Awaiting Pricing' },
          { value: m.fuel_enquiries_final_review || 0, label: 'Final Review' },
          // Only when the server sent them (ledger row 149).
          ...bunkersMoneyTiles(metrics),
        ])} />
      <ModuleCard title="Product Module" backgroundClass="product-module-bg" moduleType="product-module"
        route="/dashboard/risk-analytics" locked={!access.product} delay={200}
        metrics={v([
          { value: m.stock_items || 0, label: 'Product Items' },
          { value: m.stock_variants || 0, label: 'Variants' },
          { value: m.stock_contracts || 0, label: 'Contracts' },
        ])} />
      <ModuleCard title="CRM" backgroundClass="crm-bg" moduleType="crm"
        route="/dashboard/crm" locked={!access.crm} delay={300}
        metrics={v([
          { value: m.crm_active_profiles || 0, label: 'Active Profiles' },
          { value: m.crm_approved_kyc || 0, label: 'Approved KYC' },
          { value: m.crm_pending_review || 0, label: 'Pending Review' },
        ])} />
      <ModuleCard title="Financials" backgroundClass="financials-bg" moduleType="financials"
        route="/invoicing/dashboard" locked={!access.financials} delay={400}
        metrics={v([
          { value: m.outgoing_invoices || 0, label: 'Outgoing Invoices' },
          { value: m.proforma_invoices || 0, label: 'Pro-forma' },
          { value: m.incoming_invoices || 0, label: 'Incoming Invoices' },
          { value: m.purchase_orders || 0, label: 'Purchase Orders' },
        ])} />
      <ModuleCard title="Legal" backgroundClass="legal-bg" moduleType="legal"
        route="/dashboard/legal" locked={!access.legal} delay={500}
        metrics={v([
          { value: m.legal_total_contracts || 0, label: 'Total Contracts' },
          { value: m.legal_active_contracts || 0, label: 'Active' },
          { value: m.legal_drafts || 0, label: 'Drafts' },
        ])} />
    </div>
  );
};

export default ModulesWidget;
